module.exports = __webpack_public_path__ + "static/media/tier-gem-active.ee6242a0.svg";